import {BasicEntity} from '../../../allkey/framework/message/BasicEntity';
import {TranslatedEmb} from '../../../allkey/locale/message/TranslatedEmb';

export class Matrix extends BasicEntity {
code: string;
columns: Object;
description: TranslatedEmb;
label: TranslatedEmb;
rowCount: number | null;
rows: Object;
}

